import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Form, Input, Button} from 'antd'
import {UserOutlined, LockOutlined} from '@ant-design/icons'

function LoginForm ({onSubmit}) {
  const [form] = Form.useForm()
  const [, forceUpdate] = useState() // To disable submit button at the beginning.

  useEffect(() => {
    forceUpdate({})
  }, [])

  return (
    <Form form={form} className="login-form" onFinish={onSubmit}>
      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: 'E-post er påkrevd',
          },
        ]}
      >
        <Input prefix={<UserOutlined />} placeholder="e-post" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: 'Passord er påkrevd',
          },
        ]}
      >
        <Input prefix={<LockOutlined />} type="password" placeholder="Passord"
        />
      </Form.Item>

      <div className="recover-password">
        <a
          href="https://web.efkt.com/people/password/new"
          target="_blank"
          rel="noopener noreferrer"
        >
          Glemt passord?
        </a>
      </div>

      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            disabled={
              !form.isFieldsTouched(true) ||
              form.getFieldsError().filter(({errors}) => errors.length).length
            }
          >
            Logg inn
          </Button>
        )}
      </Form.Item>
    </Form>
  )
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default LoginForm
